/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputTextComponent} from './input-text/input-text.component';
import {WarningsModule} from '../warnings/warnings.module';
import {
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {
    NgbDatepickerConfig,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbTypeaheadModule
} from '@ng-bootstrap/ng-bootstrap';
import {InputDropdownComponent} from './input-dropdown/input-dropdown.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {InputDateComponent} from './input-date/input-date.component';
import {InputAutocompleteComponent} from './input-autocomplete/input-autocomplete.component';
import {InputUnitsComponent} from './input-units/input-units.component';
import {InputTextareaComponent} from './input-textarea/input-textarea.component';
import {InputMultiSelectComponent} from './input-multi-select/input-multi-select.component';
import {InputRadioComponent} from './input-radio/input-radio.component';
import {InputDatepickerComponent} from './input-datepicker/input-datepicker.component';
import {DecimalNumbersOnlyDirective} from './input-units/directives/decimal-numbers-only.directive';

@NgModule({
    declarations: [
        InputTextComponent,
        InputDropdownComponent,
        InputDateComponent,
        InputDatepickerComponent,
        InputAutocompleteComponent,
        InputTextareaComponent,
        InputUnitsComponent,
        InputMultiSelectComponent,
        InputRadioComponent,
        DecimalNumbersOnlyDirective
    ],
    exports: [
        InputTextComponent,
        InputDropdownComponent,
        InputDateComponent,
        InputDatepickerComponent,
        InputAutocompleteComponent,
        InputTextareaComponent,
        InputUnitsComponent,
        InputMultiSelectComponent,
        InputRadioComponent
    ],
    imports: [
        CommonModule,
        WarningsModule,
        ReactiveFormsModule,
        NgbTypeaheadModule,
        PipesModule,
        NgbDatepickerModule,
        TooltipModule,
        NgbDropdownModule,
        FormsModule
    ]
})
export class InputModule {
    constructor(datepickerConfig: NgbDatepickerConfig) {
        datepickerConfig.firstDayOfWeek = 7;
        datepickerConfig.outsideDays = 'collapsed';
        datepickerConfig.navigation = 'arrows';
    }
}
